module.exports = __webpack_public_path__ + "static/img/only.a5466f09.png";